import Dropdown from 'react-bootstrap/Dropdown';
import { useEffect, useState } from 'react';
import React from "react";

interface IProps {
  itemsList: number[];
  onChange: (number: number) => void;
  title: string;
  value?: number;
}

const CpntDropdownPage: React.FC<IProps> = ({
  onChange,
  itemsList,
  title,
  value
}) => {
    const [limit, setLimit] = useState(10);

    useEffect(() => {
        if (value || value === 0) {
            setLimit(value)
        }
      }, [value])

    const onChangeMethod = (value: number) => {
        setLimit(value)
        onChange(value);
    }

    return (
        <Dropdown>
            <Dropdown.Toggle id="dropdown-basic-button">
                {limit + " " + title}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {
                    itemsList && itemsList.map((e, index) => {
                        return <Dropdown.Item key={e + index} onClick={() => onChangeMethod(e)}>{e}</Dropdown.Item>
                    })
                }
            </Dropdown.Menu>
        </Dropdown>
    );
  };
  
  export default CpntDropdownPage;
  